/* NukkadTales — shared colour name → hex map
 *
 * Single source of truth for JS-side colour resolution.
 * Used by: nt-card.js (QV swatches), nukkad-ask-gul.js (variant picker)
 *
 * Server-side equivalent: snippets/nt-card.liquid (Liquid elsif chain)
 * When adding or changing a colour, update BOTH this file AND nt-card.liquid.
 */
window.NT_COLOR_MAP = {
  /* whites */
  white:'#f5f0e8',   ivory:'#f5f0e8',   cream:'#f5f0e8',
  /* blacks */
  black:'#222222',   ebony:'#222222',
  /* reds */
  maroon:'#c62828',  burgundy:'#c62828',
  red:'#f44336',     crimson:'#f44336',  cherry:'#f44336',
  /* blues */
  navy:'#1565c0',    indigo:'#1565c0',   cobalt:'#1565c0',  royal:'#1565c0',
  skyblue:'#87ceeb', lightblue:'#87ceeb',babyblue:'#87ceeb',
  blue:'#5b9bd5',
  /* teals */
  teal:'#26c6da',    turquoise:'#26c6da',aqua:'#26c6da',    cyan:'#26c6da',
  /* greens */
  olive:'#558b2f',   sage:'#558b2f',     forest:'#558b2f',
  mint:'#a5d6a7',    lightgreen:'#a5d6a7',limegreen:'#a5d6a7',
  green:'#66bb6a',
  /* yellows / oranges */
  mustard:'#f9a825',
  yellow:'#ffee58',  lemon:'#ffee58',
  orange:'#ff9800',  amber:'#ff9800',
  /* pinks / purples */
  peach:'#ffb3ba',
  blush:'#f48fb1',   pink:'#f48fb1',
  magenta:'#e91e8c', rose:'#e91e8c',
  lavender:'#c5cae9',
  purple:'#ab47bc',  violet:'#ab47bc',   plum:'#ab47bc',
  /* metals */
  gold:'#c9a84c',    golden:'#c9a84c',
  silver:'#9e9e9e',  chrome:'#9e9e9e',
  grey:'#757575',    gray:'#757575',
  /* woods (order matters: more specific first) */
  sheesham:'#5a3020',shisham:'#5a3020',
  mahogany:'#6b2737',rosewood:'#6b2737',
  walnut:'#4a2c0a',
  teak:'#7c4b1e',
  mango:'#a0622a',
  oak:'#b8895a',
  maple:'#c9a96e',
  pine:'#c8a96a',
  natural:'#e8d5b0', nude:'#e8d5b0',    raw:'#e8d5b0',
  brown:'#5d4037',   chocolate:'#5d4037',coffee:'#5d4037',  espresso:'#5d4037',
  wood:'#b8895a',
  /* other */
  coral:'#ff7043',   salmon:'#ff7043',
  terracotta:'#bf5530',charcoal:'#3a3a3a'
};
